import dayjs, { Dayjs } from 'dayjs'
import { Duration } from '@/components/common/duration-select'
import { DURATION_MONTH_INTEGER_MAP } from '@/hooks/use-authorization/routes'
import { Nullable } from '@/types/nullable'

const getDateRangeFromETLAt = (
  etlAt: Nullable<string>,
  range: Duration.ThreeMonths | Duration.SixMonths,
): [Dayjs, Dayjs] => {
  const rangeValue = DURATION_MONTH_INTEGER_MAP[range]
  const endDate = etlAt ? dayjs(etlAt) : dayjs()
  const startDate = dayjs(endDate).subtract(rangeValue, 'months')

  return [startDate, endDate]
}

export default getDateRangeFromETLAt
